import React, { useState, useRef, useEffect } from 'react';
import styles from "./FixedVideo.module.scss";

const FixedVideo = ({ videoUrl, posterUrl, text }) => {


    const [isPlaying, setIsPlaying] = useState(false);
    const [isMuted, setIsMuted] = useState(true);
    const [isFullScreen, setIsFullScreen] = useState(false);


    const [pauseOrPlay, setPauseOrPlay] = useState(true);


    const videoRef = useRef(null);
    const videoContainer = useRef(null);
    const videoClass = isFullScreen ? 'video_fullscreen' : 'video_normal';



    const handleVideoClick = () => {

        if (isFullScreen === false) {

            setIsFullScreen(!isFullScreen);
            videoRef.current.currentTime = 0;
            videoRef.current.play()
            setIsMuted(false);

        }
        else {

            setPauseOrPlay(!pauseOrPlay)
        }



        if (isPlaying) {

            setIsPlaying(false);

        } else {

            setIsPlaying(true);
            setIsMuted(false);

        }
    };



    //for muted video when is not fullscreen
    useEffect(() => {

        if (!isFullScreen) setIsMuted(true);

    }, [isFullScreen])


    //for play or pause
    useEffect(() => {

        if (videoRef.current) {

            pauseOrPlay ? videoRef.current.play() : videoRef.current.pause();
        }

    }, [pauseOrPlay])


    //for play or pause handler
    const handlePauseOrPlay = () => {

        setPauseOrPlay(!pauseOrPlay)
    }


    //style video inline
    const videoInlineStyle = {

        outline: "rgb(225 225 225) solid 3px",
        outlineOffset: "-3px",
        borderRadius: "50%",
        border: "#fff solid 5px",
    };


    //for fullscreen btn
    const fullScreenBtnHandler = () => {

        videoRef.current.requestFullscreen();
        // videoRef.current.webkitEnterFullscreen();
    }



    return (

        <div className={`${styles.video_container}`} ref={videoContainer}>


            {!isFullScreen && <div className={styles.video_controls1} onClick={() => videoContainer.current.style.display = "none"}>

                <svg width="64px" height="64px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M12 20.4C10.8969 20.4 9.80459 20.1827 8.78546 19.7606C7.76632 19.3384 6.84031 18.7197 6.0603 17.9397C5.28029 17.1597 4.66155 16.2337 4.23941 15.2145C3.81727 14.1954 3.6 13.1031 3.6 12C3.6 10.8969 3.81727 9.80459 4.23941 8.78546C4.66155 7.76632 5.28029 6.84031 6.0603 6.0603C6.84032 5.28029 7.76633 4.66155 8.78546 4.23941C9.8046 3.81727 10.8969 3.6 12 3.6C13.1031 3.6 14.1954 3.81727 15.2145 4.23941C16.2337 4.66155 17.1597 5.28029 17.9397 6.0603C18.7197 6.84032 19.3384 7.76633 19.7606 8.78546C20.1827 9.8046 20.4 10.8969 20.4 12C20.4 13.1031 20.1827 14.1954 19.7606 15.2145C19.3384 16.2337 18.7197 17.1597 17.9397 17.9397C17.1597 18.7197 16.2337 19.3384 15.2145 19.7606C14.1954 20.1827 13.1031 20.4 12 20.4L12 20.4Z" stroke="#2A4157" strokeOpacity="0.24" strokeWidth="1.2"></path> <path d="M9 9L15 15" stroke="#222222" strokeWidth="1.2" strokeLinecap="round"></path> <path d="M15 9L9 15" stroke="#222222" strokeWidth="1.2" strokeLinecap="round"></path> </g></svg>

            </div>}


            <div className={`${styles.videoChild} ${styles[videoClass]}`}>

                {!isFullScreen && text !== "" && <div className={styles.textOnVideo} >

                    <span>{text}</span>

                </div>}

                <video
                    className={styles.video_player}
                    playsInline
                    preload='auto'
                    src={videoUrl}
                    poster={posterUrl === "" ? "" : posterUrl}
                    autoPlay
                    loop
                    muted={isMuted}
                    onClick={handleVideoClick}
                    ref={videoRef}
                    style={isFullScreen ? {} : videoInlineStyle}
                ></video>

                {isFullScreen &&
                    <>
                        <div className={styles.video_controls2}>

                            {pauseOrPlay ?

                                <svg onClick={handlePauseOrPlay} fill="#ffffff" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" stroke="#ffffff"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>pause</title> <path d="M5.92 24.096q0 0.832 0.576 1.408t1.44 0.608h4.032q0.832 0 1.44-0.608t0.576-1.408v-16.16q0-0.832-0.576-1.44t-1.44-0.576h-4.032q-0.832 0-1.44 0.576t-0.576 1.44v16.16zM18.016 24.096q0 0.832 0.608 1.408t1.408 0.608h4.032q0.832 0 1.44-0.608t0.576-1.408v-16.16q0-0.832-0.576-1.44t-1.44-0.576h-4.032q-0.832 0-1.408 0.576t-0.608 1.44v16.16z"></path> </g></svg>

                                :

                                <svg onClick={handlePauseOrPlay} viewBox="-2.4 -2.4 28.80 28.80" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#000000" transform="matrix(1, 0, 0, 1, 0, 0)"><g id="SVGRepo_bgCarrier" strokeWidth="0" transform="translate(0,0), scale(1)"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" stroke="#d72d2d" strokeWidth="0.24000000000000005"></g><g id="SVGRepo_iconCarrier"> <path d="M16.6582 9.28638C18.098 10.1862 18.8178 10.6361 19.0647 11.2122C19.2803 11.7152 19.2803 12.2847 19.0647 12.7878C18.8178 13.3638 18.098 13.8137 16.6582 14.7136L9.896 18.94C8.29805 19.9387 7.49907 20.4381 6.83973 20.385C6.26501 20.3388 5.73818 20.0469 5.3944 19.584C5 19.053 5 18.1108 5 16.2264V7.77357C5 5.88919 5 4.94701 5.3944 4.41598C5.73818 3.9531 6.26501 3.66111 6.83973 3.6149C7.49907 3.5619 8.29805 4.06126 9.896 5.05998L16.6582 9.28638Z" stroke="#ffffff" strokeWidth="2" strokeLinejoin="round"></path> </g></svg>
                            }

                            <svg onClick={fullScreenBtnHandler} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#ffffff"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <g id="style=linear"> <g id="fullscreen"> <path id="vector" d="M8 2H4C2.89543 2 2 2.89543 2 4V8" stroke="#ffffff" strokeWidth="1.5" strokeLinecap="round"></path> <path id="vector_2" d="M22 8L22 4C22 2.89543 21.1046 2 20 2H16" stroke="#ffffff" strokeWidth="1.5" strokeLinecap="round"></path> <path id="vector_3" d="M16 22L20 22C21.1046 22 22 21.1046 22 20L22 16" stroke="#ffffff" strokeWidth="1.5" strokeLinecap="round"></path> <path id="vector_4" d="M8 22L4 22C2.89543 22 2 21.1046 2 20V16" stroke="#ffffff" strokeWidth="1.5" strokeLinecap="round"></path> </g> </g> </g></svg>


                        </div>


                        <div className={styles.video_controls3}>

                            <svg onClick={() => setIsFullScreen(false)} viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" fill="#000000"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>Close</title> <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd"> <g id="Close"> <rect id="Rectangle" fillRule="nonzero" x="0" y="0" width="24" height="24"> </rect> <line x1="16.9999" y1="7" x2="7.00001" y2="16.9999" id="Path" stroke="#ffffff" strokeWidth="2" strokeLinecap="round"> </line> <line x1="7.00006" y1="7" x2="17" y2="16.9999" id="Path" stroke="#ffffff" strokeWidth="2" strokeLinecap="round"> </line> </g> </g> </g></svg>

                        </div>

                    </>
                }

            </div>

        </div>
    );
};

export default FixedVideo;
